// extracted by mini-css-extract-plugin
module.exports = {"root":"SupportInfo_root_ehoNR","info":"SupportInfo_info_3EHD-","icon":"SupportInfo_icon_Bw8of","text":"SupportInfo_text_1-B7Z"};